import React, { useState } from "react"
import { useFieldClipboard } from "./field-clipboard-context"

export default function FieldDragDropWrapper({
  field,
  fieldValues,
  setFieldValues,
  dataItem,
  onSettingChange,
  className,
  children
}) {
  const { draggedField } = useFieldClipboard()
  const [isDragOver, setIsDragOver] = useState(false)

  const fieldType = field.type?.value || field.type

  const handleDragOver = (e) => {
    // Don't allow dropping on the same field that's being dragged
    if (draggedField &&
        draggedField.fieldType === fieldType &&
        draggedField.field.id !== field.id) {
      e.preventDefault()
      e.dataTransfer.dropEffect = "copy"
      setIsDragOver(true)
    }
  }

  const handleDragLeave = (e) => {
    // Only handle drag leave if we're actually leaving the container
    // Check if the related target is outside the container
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false)
    }
  }

  const handleDrop = (e) => {
    e.preventDefault()
    // Don't allow dropping on the same field
    if (draggedField &&
        draggedField.fieldType === fieldType &&
        draggedField.field.id !== field.id) {
      // Update field value from dragged data
      fieldValues[field.id] = draggedField.value
      if (dataItem.content) {
        dataItem.content[field.id] = draggedField.value
      }
      // Trigger re-render
      const updatedFieldValues = { ...fieldValues }
      setFieldValues(updatedFieldValues)
      if (onSettingChange) {
        onSettingChange(dataItem, field)
      }
    }
    setIsDragOver(false)
  }

  return (
    <div
      className={`${className} relative transition-all duration-200 ${
        isDragOver ? 'ring-2 ring-admin_primary border-admin_primary' : ''
      }`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {/* Drag overlay with "Paste to..." message */}
      {isDragOver && draggedField && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-admin_primary/10 rounded-lg pointer-events-none">
          <div className="bg-admin_paper px-4 py-2 rounded-lg shadow-lg border-2 border-admin_primary animate-pulse">
            <div className="text-admin_primary font-semibold text-sm">
              Paste to {field.label || field.id}
            </div>
          </div>
        </div>
      )}

      {children}
    </div>
  )
}
